import { css } from "@emotion/react";
import Image from "next/image";
import Link from "next/link";

import {
  BANNER_IMAGE_URL,
  useIsEligibleRadioForm,
} from "~/extensions/radio-form/lib";
import { mediaQueryIsDesktop } from "~/lib/client/design";

const Banner = ({ categoryId }: { categoryId: number }) => {
  const isEligible = categoryId === 160;

  return isEligible ? (
    <div css={rootStyle}>
      <Link href={`/radio/1`}>
        <Image
          src={BANNER_IMAGE_URL}
          alt={"banner"}
          width={1600}
          height={840}
          css={imageStyle}
        />
      </Link>
    </div>
  ) : null;
};

const rootStyle = css`
  cursor: pointer;

  ${mediaQueryIsDesktop(css`
    width: 100%;
    display: flex;
    justify-content: center;
  `)};
`;

const imageStyle = css`
  cursor: pointer;
  border-radius: 0.25rem;
  width: 100%;
  height: auto;

  ${mediaQueryIsDesktop(css`
    max-width: 600px;
    margin: 1rem auto;
  `)};
`;

export default Banner;
